import { render, staticRenderFns } from "./WorkQueueChrome.vue?vue&type=template&id=6eb0b889&scoped=true"
import script from "./WorkQueueChrome.vue?vue&type=script&lang=js"
export * from "./WorkQueueChrome.vue?vue&type=script&lang=js"
import style0 from "./WorkQueueChrome.vue?vue&type=style&index=0&id=6eb0b889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb0b889",
  null
  
)

export default component.exports